import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ReclamacionModel } from '../../models/Reclamacion';
import { ModelHelpers } from '../../models/ModelHelpers';
import { ErrorHelper } from '../../models/ErrorHelper';
import { TasacionesService } from '../../services/tasaciones.service';
import { ReclamacionesService } from '../../services/reclamaciones.service';
import { ModalDefaultComponent } from '../controls/modal-default/modal-default.component';

@Component({
  selector: 'app-tasacion-reclamacion-edit',
  templateUrl: './tasacion-reclamacion-edit.component.html',
  styleUrls: ['./tasacion-reclamacion-edit.component.scss']
})
export class TasacionReclamacionEditComponent implements OnInit {
  formGroup: FormGroup;
  tasacionId: number;
  model: ReclamacionModel = new ReclamacionModel();
  errorMessage: string = '';

  constructor(public dialogRef: MatDialogRef<TasacionReclamacionEditComponent>, private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private _avRoute: ActivatedRoute, private _reclamacionesService: ReclamacionesService,
    public matDialog: MatDialog) {
    // console.log(data)
      if (data !== null) {
      this.tasacionId = data.id;
      if (data.model !== null)
        this.model = data.model;
    }
  }

  get solucionReclamacion() {
    return this.formGroup.get('solucionReclamacion');
  }

  ngOnInit() {
    this.buildForm();
    this.bindFromModel();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  buildForm() {
    if(this.model == undefined) this.model = new ReclamacionModel();
    this.formGroup = this._fb.group({
      ID: 0,
      fechaFin: new Date(),
      tasacionID: [this.tasacionId],
      solucionReclamacion: ['', Validators.required]
    })
  }

  bindFromModel() {
    this.formGroup.patchValue({
      ID: this.model.ID,
      tasacionID: this.tasacionId
    });
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);
  }

  async onSubmit() {
    if (!this.formGroup.valid)
      return

    this.bindToModel();

    if (this.tasacionId != 0) {
      if (this.formGroup.value != null) {
        try {
          this._reclamacionesService.close(this.model.tasacionID, this.model)
            .subscribe((data) => {
              this.closeDialog();
            })
        
    
        } catch (error) {
          let errorMessage = ErrorHelper.GetClientError(error);
          this.errorMessage = errorMessage;
        }
      }
    }
    let result = null
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  confirmAnswer() {
    if (this.formGroup.value.solucionReclamacion != '') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = "350px"
      dialogConfig.data = {
        title: 'Atención',
        confirmText: 'Confirmar',
        // classColor: 'button-danger',
        message: `¿Está seguro de que la reclamación está cerrada? Esto modificará el estado y finalizará la tramitación de la reclamación.`,
      };
      const ref = this.matDialog.open(ModalDefaultComponent, dialogConfig);
      ref.afterClosed().subscribe(async result => {
        if (result) {
          await this.onSubmit();
        } else {
          this.onNoClick();
        }
      });
    }

  }

}
